import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UInputComponent } from './u-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { UIconModule } from '../u-icon/u-icon.module';
import { AutoFitWidthDirective } from '../../directives/auto-fit-width.directive';

const directives = [AutoFitWidthDirective];

@NgModule({
  declarations: [...directives, UInputComponent],
  imports: [CommonModule, FormsModule, InputTextModule, TooltipModule, UIconModule, ReactiveFormsModule],
  exports: [...directives, UInputComponent],
})
export class UInputModule {}
